import type { GlobalEvents } from "@storytell/types";

const globalEventTarget = new EventTarget();

// Helper function to dispatch custom events with data
export function dispatchGlobalEvent<T extends keyof GlobalEvents>(eventName: T, data: GlobalEvents[T]["data"]) {
  const customEvent = new CustomEvent(eventName, {
    detail: data,
  });
  globalEventTarget.dispatchEvent(customEvent);
}

// Helper function to listen for custom events
export function subscribeToGlobalEvent<T extends keyof GlobalEvents>(
  eventName: T,
  callback: (event: CustomEvent<GlobalEvents[T]["data"]>) => void,
) {
  const handler = (event: Event) => {
    if (event instanceof CustomEvent) {
      callback(event);
    }
  };

  globalEventTarget.addEventListener(eventName, handler);

  // Return cleanup function
  return () => {
    globalEventTarget.removeEventListener(eventName, handler);
  };
}
